export const emailIpWarmingAppGroupIdPlan = "/email/ip_warming/:app_group_id/plan(/:plan_id)";
